export default __webpack_public_path__ + "static/media/news-3.2ed12f88.png";